/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _style10 = require("antd/lib/card/style");

var _card = require("antd/lib/card");

var _card2 = _interopRequireDefault(_card);

var _style11 = require("antd/lib/table/style");

var _table = require("antd/lib/table");

var _table2 = _interopRequireDefault(_table);

var _style12 = require("antd/lib/col/style");

var _col = require("antd/lib/col");

var _col2 = _interopRequireDefault(_col);

var _style13 = require("antd/lib/row/style");

var _row = require("antd/lib/row");

var _row2 = _interopRequireDefault(_row);

var _style14 = require("antd/lib/icon/style");

var _icon = require("antd/lib/icon");

var _icon2 = _interopRequireDefault(_icon);

var _jsx2 = require("babel-runtime/helpers/jsx");

var _jsx3 = _interopRequireDefault(_jsx2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _style15 = require("antd/lib/message/style");

var _message = require("antd/lib/message");

var _message2 = _interopRequireDefault(_message);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _style16 = require("antd/lib/tabs/style");

var _tabs = require("antd/lib/tabs");

var _tabs2 = _interopRequireDefault(_tabs);

var _style17 = require("antd/lib/radio/style");

var _radio = require("antd/lib/radio");

var _radio2 = _interopRequireDefault(_radio);

var _style18 = require("antd/lib/date-picker/style");

var _datePicker = require("antd/lib/date-picker");

var _datePicker2 = _interopRequireDefault(_datePicker);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require("react-router");

var _redux = require("redux");

var _reactRedux = require("react-redux");

var _immutable = require("immutable");

var _actions = require("../../../redux/actions");

var Actions = _interopRequireWildcard(_actions);

var _tool = require("util/tool");

var _config = require("util/config");

var _tpl = require("tpl");

var _tpl2 = _interopRequireDefault(_tpl);

var _comps = require("comps");

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

var _gps = require("../../../utils/gps");

var _gps2 = _interopRequireDefault(_gps);

var _dateFormat = require("../../../utils/dateFormat");

var _dateFormat2 = _interopRequireDefault(_dateFormat);

require("./index.less");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import {Table } from 'antd'
var MonthPicker = _datePicker2.default.MonthPicker,
    RangePicker = _datePicker2.default.RangePicker;

var RadioGroup = _radio2.default.Group;
var RadioButton = _radio2.default.Button;

var dateFormat = "YYYY-MM-DD";
var monthFormat = "YYYY-MM";
var TabPane = _tabs2.default.TabPane;
var ins = {
  posData: ""
};

var _ref = (0, _jsx3.default)("div", {
  className: "empty-msg"
}, void 0, "\u6682\u65E0\u6570\u636E");

var _ref2 = (0, _jsx3.default)("strong", {}, void 0, "\u56FA\u4EF6\u7248\u672C");

var _ref3 = (0, _jsx3.default)("div", {
  className: "gray"
}, void 0, (0, _jsx3.default)("span", {}, void 0, "\u5F53\u524D\u7248\u672C\uFF1A"));

var Main = function (_Component) {
  (0, _inherits3.default)(Main, _Component);

  function Main(props, context) {
    (0, _classCallCheck3.default)(this, Main);

    // this.state = 0;
    // console.log(props,'-------------------')
    var _this2 = (0, _possibleConstructorReturn3.default)(this, (Main.__proto__ || (0, _getPrototypeOf2.default)(Main)).call(this, props, context));

    _this2.showErrDetail = function (e) {
      // console.log(e.target.dataset.detail);
      var warningLable = JSON.parse(e.target.dataset.detail);
      var errDes = '';
      _this2.gzxxNameList.map(function (val) {
        if (warningLable.alarmType == val.name) {
          errDes = val.val;
        }
      });
      var lastHeartbeatTime = warningLable.lastHeartbeatTime,
          alarmLevel = warningLable.alarmLevel,
          alarmName = warningLable.alarmName;

      lastHeartbeatTime = lastHeartbeatTime ? _tool.tool.formatTime(lastHeartbeatTime.replace(/\-/g, '/'), '-') : '';
      switch (alarmLevel) {
        case 0:
          alarmLevel = '正常';
          break;
        case 1:
          alarmLevel = '一级';
          break;
        case 2:
          alarmLevel = '二级';
          break;
        case 3:
          alarmLevel = '三级';
          break;
      }
      var resString = "\u6545\u969C\u8BE6\u60C5\n\r\u6545\u969C\u63CF\u8FF0\uFF1A" + alarmName + "\n\r\u89E6\u53D1\u65F6\u95F4\uFF1A" + lastHeartbeatTime + "\n\r\u6545\u969C\u7B49\u7EA7\uFF1A" + alarmLevel;
      _this2.setState({
        warningLable: resString
      });
    };

    _this2.handleTimeChange = function (e) {
      _this2.getCurrentTime(e.target.value);
      _this2.setState({ kind: e.target.value });
    };

    _this2.tabCallback = function () {};

    _this2.state = {
      infoSOC: '',
      infos: {},
      liyujiang: {},
      kzq: {},
      qddj: {},
      gzxx: [],
      deviceInfo: {},
      indexX: '',
      area: "xxx",
      startTime: "2018-01-01",
      endTime: "2018-01-31",
      kind: "week",
      timeValue: [(0, _moment2.default)("2018-01-01", dateFormat), (0, _moment2.default)("2018-01-31", dateFormat)],
      page: 1,
      page2: 1,
      records: [],
      total: 0,
      total2: 0,
      loadings: false,
      relativeDeviceList: [],
      formattedAddress: "--",
      lnglat: [],
      errData: [],
      warningLable: '',
      bmsVolDatas: {},
      bmsTempData: {},
      vehExtremeChargingDeviceData: {},
      batNum: null,
      tempNum: null,
      reportingTime: null,
      reportingTime2: null
    };
    _this2.gzxxNameList = [{
      name: 'COMPONENT_MCCU',
      val: 'MCCU故障'
    }, {
      name: 'COMPONENT_VCU',
      val: 'VCU故障'
    }, {
      name: 'COMPONENT_BMS',
      val: 'BMS故障'
    }, {
      name: 'COMPONENT_ICM',
      val: 'ICM故障'
    }, {
      name: 'UNKNOWN_COMPONENT_TYPE',
      val: '未知故障'
    }];
    return _this2;
  }

  (0, _createClass3.default)(Main, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(0, _immutable.is)((0, _immutable.fromJS)(this.props), (0, _immutable.fromJS)(nextProps)) || !(0, _immutable.is)((0, _immutable.fromJS)(this.state), (0, _immutable.fromJS)(nextState));
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;

      var _props = this.props,
          params = _props.params,
          getDeviceDetail = _props.getDeviceDetail;
      // getDeviceDetail({
      //   deviceId: params.eid
      // })
      //this.fetch()
      //this.fetchRelativeDevices()

      this.getDeviceDetailByDeviceId();
      (0, _tool.http)(_config.apiJson.getDeviceDetailByType, {
        deviceId: params.eid,
        queryType: 'overallData'
      }).then(function (res) {
        console.log(Date(res), '更新时间');
        _this3.setState({
          infoSOC: res.overallData.socStatus ? res.overallData.socStatus : {},
          loadings: false
        });
      }, function (res) {});
    }
    // 展示详细的错误信息

  }, {
    key: "getDeviceDetailByDeviceId",
    value: function getDeviceDetailByDeviceId() {
      var _this4 = this;

      var params = this.props.params;

      (0, _tool.http)(_config.apiJson.getDeviceDetailByDeviceId, {
        deviceId: params.eid
      }).then(function (res) {
        _this4.setState({
          deviceInfo: res,
          loadings: false
        });
        var lnglat = res.deviceInfo.vehiclePosVo;
        if (lnglat) {
          _this4.posToAddress(lnglat.lon, lnglat.lat);
        }
      }, function (res) {
        //Message.error(res.errmsg)
      });
    }
  }, {
    key: "getDeviceDetailsInfo",
    value: function getDeviceDetailsInfo(types, page) {
      var _this5 = this;

      var params = this.props.params;

      var _this = this;
      switch (types) {
        case 'essentialInfo':
          (0, _tool.http)(_config.apiJson.getDeviceDetailByDeviceId, {
            deviceId: params.eid
          }).then(function (res) {
            // console.log(res)
            _this5.setState({
              deviceInfo: res,
              loadings: false
            });
          });
          (0, _tool.http)(_config.apiJson.getDeviceDetailByType, {
            deviceId: params.eid,
            queryType: 'overallData'
          }).then(function (res) {
            console.log(Date(res), '更新时间');
            _this5.setState({
              infoSOC: res.overallData.socStatus ? res.overallData.socStatus : {},
              loadings: false
            });
          }, function (res) {});
          break;
        case 'overallData':
          (0, _tool.http)(_config.apiJson.getDeviceDetailByType, {
            deviceId: params.eid,
            queryType: types
          }).then(function (res) {
            _this5.setState({
              infos: res.overallData ? res.overallData : {},
              loadings: false
            });
          }, function (res) {});
          break;
        case 'posData':
          (0, _tool.http)(_config.apiJson.getDeviceDetailByType, {
            deviceId: params.eid,
            queryType: types
          }).then(function (res) {
            setTimeout(function () {
              // let gps = [res.longitude, res.latitude]
              // new AMap.convertFrom(gps, 'gps', (status, result) => {
              //   if (result.info === 'ok') {
              //     let lnglats = result.locations; // Array.<LngLat></LngLat>
              //     this.setState({
              //       lnglat: lnglats
              //     })
              //   }
              // });
              var lnglats = _gps2.default.wgs84togcj02(res.posData.data.longitude, res.posData.data.latitude);
              window.map = new AMap.Map("container", {
                resizeEnable: true, //是否监控地图容器尺寸变化
                zoom: 100, //初始化地图层级
                center: lnglats //初始化地图中心点
              });
              // 构造点标记
              var marker = new AMap.Marker({
                icon: "https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
                position: lnglats
              });
              // 将以上覆盖物添加到地图上
              // 单独将点标记添加到地图上
              map.add(marker);
              // add方法可以传入一个覆盖物数组，将点标记和矢量圆同时添加到地图上
              map.add([marker]);
              var geocoder = new AMap.Geocoder({
                radius: 1000,
                extensions: "all"
              });
              geocoder.getAddress(lnglats, function (status, result) {
                if (status === 'complete' && result.info === 'OK') {
                  geocoder_CallBack(result);
                }
              });
              function geocoder_CallBack(data) {
                _this.setState({
                  area: data.regeocode.formattedAddress,
                  loadings: false

                });
              }
            }, 500);
            _this5.setState({
              reportingTime: res.posData.cheatTime ? _tool.tool.formatTime(res.posData.cheatTime) : '',
              reportingTime2: res.posData.data.time ? _tool.tool.formatTime(res.posData.data.time) : ''
            });
          }, function (res) {
            //Message.error(res.errmsg)
          });

          break;
        case 'bmsVolData':
          (0, _tool.http)(_config.apiJson.getDeviceDetailByType, {
            deviceId: params.eid,
            queryType: types
          }).then(function (res) {
            _this5.setState({
              bmsVolDatas: res.bmsVolData ? res.bmsVolData : {},
              vehExtremeChargingDeviceData: res.vehExtremeChargingDeviceData ? res.vehExtremeChargingDeviceData : {},
              bmsTempData: res.bmsTempData ? res.bmsTempData : {},
              batNum: res.bmsVolData.volList.length || '--',
              tempNum: res.bmsTempData.tempList.length || '--',
              loadings: false

            });
          }, function (res) {});
          break;
        case 'driveData':
          (0, _tool.http)(_config.apiJson.getDeviceDetailByType, {
            deviceId: params.eid,
            queryType: types
          }).then(function (res) {
            _this5.setState({
              qddj: res.driveData ? res.driveData : {},
              loadings: false

            });
          }, function (res) {});
          break;
        case 'obcData':
          (0, _tool.http)(_config.apiJson.getDeviceDetailByType, {
            deviceId: params.eid,
            queryType: types
          }).then(function (res) {
            _this5.setState({
              kzq: res.obcData ? res.obcData : {},
              loadings: false

            });
          }, function (res) {});
          break;
        case 'alarmData':
          (0, _tool.http)(_config.apiJson.getDeviceDetailByType, {
            deviceId: params.eid,
            queryType: types
            // page: page ? page : 1
          }).then(function (res) {
            _this5.setState({
              gzxx: res ? res.alarmData : [],
              loadings: false
            });
          }, function (res) {});
          break;

      }
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      var params = this.props.params;
      // http(apiJson.getDeviceDetailByType, {
      //   deviceId: params.eid,
      //   queryType: 'bmsVolData'
      // }).then(
      //   res => {
      //     liyujiang = res
      //   },
      //   res => {

      //   }
      // );

      // this.getDeviceDetailsInfo('overallData');
      // this.getDeviceDetailsInfo('obcData');
      // this.getDeviceDetailsInfo('driveData');
      // this.getDeviceDetailsInfo('bmsVolData');
    }
  }, {
    key: "getWeekStartDate",
    value: function getWeekStartDate(nowYear, nowMonth, nowDay, nowDayOfWeek) {
      var weekStartDate = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek);
      return this.formatDate(weekStartDate);
    }
    //获得本周的结束日期

  }, {
    key: "getWeekEndDate",
    value: function getWeekEndDate(nowYear, nowMonth, nowDay, nowDayOfWeek) {
      var weekEndDate = new Date(nowYear, nowMonth, nowDay + (6 - nowDayOfWeek));
      return this.formatDate(weekEndDate);
    }
  }, {
    key: "getMonthStartDate",
    value: function getMonthStartDate(nowYear, nowMonth) {
      var monthStartDate = new Date(nowYear, nowMonth, 1);
      return this.formatDate(monthStartDate);
    }
  }, {
    key: "getMonthEndDate",
    value: function getMonthEndDate(nowYear, nowMonth) {
      var monthEndDate = new Date(nowYear, nowMonth, this.getMonthDays(nowYear, nowMonth));
      return this.formatDate(monthEndDate);
    }
  }, {
    key: "getMonthDays",
    value: function getMonthDays(nowYear, myMonth) {
      var monthStartDate = new Date(nowYear, myMonth, 1);
      var monthEndDate = new Date(nowYear, myMonth + 1, 1);
      var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
      return days;
    }
  }, {
    key: "formatDate",
    value: function formatDate(date) {
      var myyear = date.getFullYear();
      var mymonth = date.getMonth() + 1;
      var myweekday = date.getDate();
      if (mymonth < 10) {
        mymonth = "0" + mymonth;
      }
      if (myweekday < 10) {
        myweekday = "0" + myweekday;
      }
      return myyear + "/" + mymonth + "/" + myweekday;
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime(kind) {
      var now = new Date(); //当前日期
      var nowDayOfWeek = now.getDay(); //今天本周的第几天
      var nowDay = now.getDate(); //当前日
      var nowMonth = now.getMonth(); //当前月
      var nowYear = now.getYear(); //当前年
      nowYear += nowYear < 2000 ? 1900 : 0; //
      var startTime = "";
      var endTime = "";

      if (kind == "week") {
        startTime = this.getWeekStartDate(nowYear, nowMonth, nowDay, nowDayOfWeek);
        endTime = this.getWeekEndDate(nowYear, nowMonth, nowDay, nowDayOfWeek);
      } else {
        startTime = this.getMonthStartDate(nowYear, nowMonth);
        endTime = this.getMonthEndDate(nowYear, nowMonth);
      }

      this.setState({
        startTime: startTime,
        endTime: endTime,
        timeValue: [(0, _moment2.default)(startTime, dateFormat), (0, _moment2.default)(endTime, dateFormat)]
      });
    }
  }, {
    key: "getTime",
    value: function getTime() {
      var myDate = new Date();
      var year = myDate.getFullYear();
      var month = myDate.getMonth() + 1;
      var date = myDate.getDate();
      var hour = myDate.getHours();
      var minute = myDate.getMinutes();
      var seconds = myDate.getSeconds();

      return {
        start: year + "-" + month + "-" + date + " 00:00:00",
        end: year + "-" + month + "-" + date + " 23:59:59"
      };
    }

    // fetch(){
    //   let {params} = this.props
    //   let {eid} = params

    //   http(apiJson.getDataInfoList, {
    //     deviceId: eid
    //   }).then(res => {
    //     if(res && res.length > 0){
    //       this.setState({
    //         records: res,
    //         total: res.length
    //       })
    //     }
    //   }, res => {
    //     //Message.error(res.errmsg)
    //   })
    // }

    // fetchRelativeDevices() {
    //   let {params} = this.props
    //   let {eid} = params
    //   http(apiJson.getDeviceOrSocketRel, {
    //     socketCode: eid
    //   }).then(res => {
    //     let {deviceList, socketList} = res

    //     this.setState({
    //       relativeDeviceList: subDeviceList,
    //       //elativeSocketList: socketList
    //     })
    //   }, res => {

    //   })
    // }

  }, {
    key: "unbindDevice",
    value: function unbindDevice() {
      var _this6 = this;

      var serialNumber = this.state.deviceInfo.deviceInfo.serialNumber;

      (0, _tool.http)(_config.apiJson.deleteDeviceRelationship, {
        serialNumber: serialNumber
      }).then(function (res) {
        if (res) {
          _message2.default.success("解除绑定成功");
          _this6.getDeviceDetailByDeviceId();
        } else {
          _message2.default.error("解除绑定失败");
        }
      });
    }
  }, {
    key: "exportExcel",
    value: function exportExcel() {
      var qTime = this.getTime();
      var page = this.state.page;
      var params = this.props.params;
      var eid = params.eid;


      window.open(_config.target + "/device/exportExcel?page=" + page + "&rows=10&deviceId=" + eid + "&startTime=" + qTime.start + "&endTime=" + qTime.end);
    }
  }, {
    key: "filterOutputTorque",
    value: function filterOutputTorque(val) {
      var str = '';
      switch (true) {
        case -2000 < val < 0:
          str = '反转';
          break;
        case 0 < val < 2000:
          str = '驱动';
          break;
        case val === 0:
          str = '静止';
          break;
        case val < -2000:
          str = '异常';
          break;
        case val > 2000:
          str = '异常';
          break;
        default:
          str = '--';
          break;
      }
      return str;
    }
  }, {
    key: "posToAddress",
    value: function posToAddress(lon, lat) {
      var _this = this;
      AMap.plugin("AMap.Geocoder", function () {
        var geocoder = new AMap.Geocoder({});
        var lnglat = [lon, lat];
        AMap.convertFrom(lnglat, "gps", function (status, result) {
          if (result.info === "ok") {
            var lnglats = [result.locations[0].lng, result.locations[0].lat];
            geocoder.getAddress(lnglats, function (status, res) {
              if (status === "complete" && res.info === "OK") {
                // result为对应的地理位置详细信息
                _this.setState({
                  formattedAddress: res.regeocode.formattedAddress
                });
              } else if (status === "no_data") {
                _this.setState({
                  formattedAddress: "当前车辆位置无法获取"
                });
              }
            });
          }
        });
      });
    }
  }, {
    key: "onChange",
    value: function onChange(val) {
      var gzxx = this.state.gzxx;

      if (val) {
        this.setState({
          page2: val.current
        });
      }
      var pg = null;
      if (val.current !== 1) {
        pg = (val.current - 1) * val.pageSize;
      }
      var num = gzxx.length;
      if (num > pg + val.pageSize) {
        this.setState({
          errData: gzxx.slice(pg, pg + val.pageSize)
        });
      } else {
        this.setState({
          errData: gzxx.slice(pg, gzxx.length)
        });
      }
    }
  }, {
    key: "compare",
    value: function compare(property) {
      return function (a, b) {
        var value1 = a[property];
        var value2 = b[property];
        return value2 - value1;
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this7 = this;

      var params = this.props.params;
      var _state = this.state,
          records = _state.records,
          total = _state.total,
          total2 = _state.total2,
          page = _state.page,
          page2 = _state.page2,
          deviceInfo = _state.deviceInfo,
          formattedAddress = _state.formattedAddress,
          infos = _state.infos,
          gzxx = _state.gzxx,
          infoSOC = _state.infoSOC,
          liyujiang = _state.liyujiang,
          kzq = _state.kzq,
          vehExtremeChargingDeviceData = _state.vehExtremeChargingDeviceData,
          bmsVolDatas = _state.bmsVolDatas,
          bmsTempData = _state.bmsTempData,
          tempNum = _state.tempNum,
          batNum = _state.batNum,
          reportingTime = _state.reportingTime,
          reportingTime2 = _state.reportingTime2,
          qddj = _state.qddj;
      var id = params.id;

      var paginations = {
        defaultCurrent: 1,
        current: page2,
        total: total2,
        pageSize: 10,
        showTotal: function showTotal(total) {
          return "\u5171\u8BA1 " + total + " \u6761";
        },
        showQuickJumper: true
      };
      var errData = gzxx.sort(this.compare('lastHeartbeatTime')).map(function (item, index) {
        var a = '';
        var b = '';
        switch (item.alarmLevel) {
          case 0:
            a = '正常';
            break;
          case 1:
            a = '一级';
            break;
          case 2:
            a = '二级';
            break;
          case 3:
            a = '三级';
            break;
        }
        switch (item.alarmStatus) {
          case 0:
            b = '解除';
            break;
          case 1:
            b = '触发';
            break;
        }
        return (0, _extends3.default)({}, item, {
          num: index + 1,
          alarmLevel: a,
          alarmStatus: b
        });
      });
      var subDeviceList = deviceInfo.subDeviceList ? deviceInfo.subDeviceList : {};
      var subDeviceType = deviceInfo.subDeviceType;
      var leverArr = gzxx.map(function (item) {
        return item.alarmLevel;
      });

      leverArr.sort(function (a, b) {
        return a - b;
      });
      // let baseInfo = deviceInfo.baseInfo ? deviceInfo.baseInfo : {};
      // let extraInfo = deviceInfo.extraInfo ? deviceInfo.extraInfo : {};
      var deviInfo = deviceInfo.deviceInfo ? deviceInfo.deviceInfo : {};
      var dataSourcex = [];
      if (deviInfo.deviceVersionVo) {
        dataSourcex = deviInfo.deviceVersionVo.map(function (item, index) {
          return {
            key: index,
            partName: filterEmpty(item.partName) || '--',
            partCode: filterEmpty(item.partCode) || '--',
            partID: filterEmpty(item.id) || '--',
            partFirmwareVersion: filterEmpty(item.partFirmwareVersion) || '--'
          };
        });
      }
      var columnsx = [{
        title: '部件名称',
        dataIndex: 'partName',
        align: 'center'
      }, {
        title: '部件代码',
        dataIndex: 'partCode'
      }, {
        title: '部件ID',
        dataIndex: 'partID'
      }, {
        title: '软件版本',
        dataIndex: 'partFirmwareVersion'
      }];
      //let onlineState = extraInfo.onlineState == 1 ? '在线' : '离线'
      var onlineStatus = deviInfo.onlineStatus == 1 ? "在线" : "离线";
      var onlineClass = deviInfo.onlineStatus == 1 ? "online" : "outline";
      var _state2 = this.state,
          startTime = _state2.startTime,
          endTime = _state2.endTime,
          kind = _state2.kind,
          timeValue = _state2.timeValue;

      var columns = [{
        title: "序号",
        dataIndex: "no",
        sorter: function sorter(a, b) {
          return a.no - b.no;
        },
        render: function render(text) {
          return (page - 1) * 10 + text + 1;
        }
      }, {
        title: "上报类型",
        dataIndex: "eventType"
      }, {
        title: "最近心跳时间",
        dataIndex: "createTime",
        render: function render(text) {
          return new Date(parseInt(text)).toLocaleString().replace(/\//g, "-");
        }
      }];
      var columnTwo = [{
        title: '序号',
        dataIndex: 'num',
        key: 'num'
      }, {
        title: '故障码',
        dataIndex: 'alarmCode',
        key: 'alarmCode'
      }, {
        title: '故障描述',
        dataIndex: 'alarmName',
        key: 'alarmName'
      }, {
        title: '级别',
        dataIndex: 'alarmLevel',
        key: 'alarmLevel'
      }, {
        title: '状态',
        dataIndex: 'alarmStatus',
        key: 'alarmStatus'
      }, {
        title: '时间',
        dataIndex: 'lastHeartbeatTime',
        render: function render(text) {
          // console.log(text,'看看时间')
          return new Date(parseInt(text)).toLocaleString().replace(/\//g, "-");
        }
      }];
      var pagination = {
        defaultCurrent: 1,
        total: total,
        pageSize: 10,
        showTotal: function showTotal(total) {
          return "\u5171\u8BA1 " + total + " \u6761";
        },
        showQuickJumper: true
      };

      var data = records;
      data.map(function (item, index) {
        item.no = index;
      });

      function filterEmpty(str) {
        return str || str == 0 ? "" + str : "--";
      }
      function gjxxEmpty(str) {
        if (str.length > 0) {
          return "\u6545\u969C\u7F16\u7801\uFF1A" + str.join(',');
        } else {
          return '';
        }
      }
      var listTpl = [];

      if (subDeviceList.length > 0) {
        listTpl = subDeviceList.map(function (item, key) {
          var bindClass = item.bindStatus == 0 ? "unbind" : item.bindStatus == 1 ? "binding" : "bind";
          var bindStatus = _tool.filter.SubDeviceBindStatus(item.bindStatus);
          return (0, _jsx3.default)("div", {
            className: "el"
          }, key, (0, _jsx3.default)("p", {}, void 0, subDeviceType == 1 ? _tool.filter.SocketType(item.deviceType) : _tool.filter.accessDeviceType(item.deviceType), " "), (0, _jsx3.default)("p", {}, void 0, item.subDeviceCode), (0, _jsx3.default)("div", {
            className: "el-status"
          }, void 0, "\u72B6\u6001:", (0, _jsx3.default)("span", {
            className: bindClass
          }, void 0, bindStatus)), subDeviceType == 1 ? "" : (0, _jsx3.default)("div", {
            className: "el-wifi " + (item.onlineStatus ? "wifi-online" : "wifi-outline")
          }));
        });
      }

      if (listTpl.length == 0) {
        listTpl = _ref;
      }
      return (0, _jsx3.default)("div", {
        className: "device-detail devive-title"
      }, void 0, (0, _jsx3.default)("p", {}, void 0, (0, _jsx3.default)("span", {}, void 0, "VIN\u7801\uFF1A", deviInfo.serialNumber), (0, _jsx3.default)("span", {
        className: "device-status device-detail-online " + onlineClass
      }, void 0, onlineStatus), (0, _jsx3.default)(_icon2.default, {
        type: "sync",
        onClick: function onClick() {
          switch (parseInt(_this7.state.indexX)) {
            case 1:
              _this7.getDeviceDetailsInfo('essentialInfo');
              break;
            case 2:
              _this7.getDeviceDetailsInfo('posData');
              _this7.getDeviceDetailsInfo('overallData');
              break;
            case 3:
              _this7.getDeviceDetailsInfo('bmsVolData');
              break;
            case 4:
              _this7.getDeviceDetailsInfo('driveData');
              break;
            case 5:
              _this7.getDeviceDetailsInfo('obcData');
              break;
            case 6:
              _this7.getDeviceDetailsInfo('alarmData');
              break;
          }
          _this7.setState({
            loadings: true
          });
        },
        spin: this.state.loadings,
        style: { fontSize: "28px", marginLeft: "12px", cursor: "pointer" }
      })), (0, _jsx3.default)(_tabs2.default, {
        defaultActiveKey: "1",
        onChange: function onChange(key) {
          _this7.setState({
            indexX: key
          });
          switch (parseInt(key)) {
            case 1:
              _this7.getDeviceDetailsInfo('essentialInfo');
              break;
            case 2:
              _this7.getDeviceDetailsInfo('posData');
              _this7.getDeviceDetailsInfo('overallData');
              break;
            case 3:
              _this7.getDeviceDetailsInfo('bmsVolData');
              break;
            case 4:
              _this7.getDeviceDetailsInfo('driveData');
              break;
            case 5:
              _this7.getDeviceDetailsInfo('obcData');
              break;
            case 6:
              _this7.getDeviceDetailsInfo('alarmData');
              break;
          }
        }
      }, void 0, (0, _jsx3.default)(TabPane, {
        tab: "\u57FA\u672C\u4FE1\u606F"
      }, "1", (0, _jsx3.default)("div", {
        className: "device-detail"
      }, void 0, (0, _jsx3.default)(_row2.default, {
        className: "device-detail-banner"
      }, void 0, (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u6240\u5C5E\u578B\u53F7\uFF1A", _tool.filter.accessDeviceType(deviInfo.accessDeviceType)), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u51FA\u5382\u65F6\u95F4\uFF1A", deviInfo.createTime ? _tool.tool.formatTime(deviInfo.createTime.replace(/\-/g, '/')) : ''), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "sim\u5361\uFF1A", filterEmpty(deviInfo.simIccid)), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u6E20\u9053\uFF1A", filterEmpty(deviInfo.channelName)), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u84DD\u7259ID\uFF1A", filterEmpty(deviInfo.bleId)), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u84DD\u7259MAC\uFF1A", filterEmpty(deviInfo.bleMacAddr)), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u84DD\u7259\u6A21\u5757\u7248\u672C\uFF1A", deviInfo.bleModuleVersion || '--'), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u901A\u8BAF\u6A21\u5757\u6A21\u5757\u7248\u672C\uFF1A", deviInfo.netModuleVersion || '--'), deviInfo.accessDeviceType === 117 || deviInfo.accessDeviceType === 118 ? (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u7F51\u7EDC\u6A21\u5757IMEI\u53F7\uFF1A", deviInfo.imeiNo || '--') : null, deviInfo.thirdDeviceId && (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u94A2\u67B6\u53F7\uFF1A", deviInfo.thirdDeviceId || '--')), (0, _jsx3.default)(_row2.default, {
        className: "device-detail-banner"
      }, void 0, (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "SOC\uFF1A", _tool.filter.socStatus(infoSOC)), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u7ED1\u5B9A\u65F6\u95F4\uFF1A ", deviInfo.bindTime ? deviInfo.bindTime : "未绑定"), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u7ED1\u5B9A\u7528\u6237\uFF1A", deviInfo.bindUser ? deviInfo.bindUser : "无")), (0, _jsx3.default)(_row2.default, {
        className: "device-detail-banner"
      }, void 0, (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u6700\u8FD1\u6D3B\u8DC3\u65F6\u95F4\uFF1A", deviInfo.lastHeartbeatTime ? _tool.tool.formatTime(deviInfo.lastHeartbeatTime.replace(/\-/g, '/')) : '')), (0, _jsx3.default)(_row2.default, {
        className: "version"
      }, void 0, (0, _jsx3.default)(_col2.default, {
        span: 24,
        className: "ele-0"
      }, void 0, (0, _jsx3.default)("div", {}, void 0, _ref2, _ref3, (0, _jsx3.default)(_table2.default, {
        dataSource: dataSourcex,
        columns: columnsx,
        className: "list",
        pagination: false
      })))), (0, _jsx3.default)(_row2.default, {
        className: "records"
      }, void 0, (0, _jsx3.default)(_col2.default, {
        span: 24,
        className: "ele-0"
      }, void 0)))), (0, _jsx3.default)(TabPane, {
        tab: "\u6574\u8F66\u72B6\u6001"
      }, "2", (0, _jsx3.default)(_row2.default, {
        className: "device-detail-banner"
      }, void 0, (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "SOC:\u3000", filterEmpty(infos.socStatus), "%"), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "SOH:\u3000", infos.soh != 255 ? infos.soh == 254 ? '异常' : filterEmpty(infos.soh) + "%" : '无效'), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u7EED\u822A\u91CC\u7A0B:\u3000", infos.enduranceMileage ? infos.enduranceMileage == 65535 || infos.enduranceMileage == 65534 ? '--' : filterEmpty(infos.enduranceMileage / 10) : filterEmpty(infos.enduranceMileage), "Km"), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u7D2F\u8BA1\u91CC\u7A0B:\u3000", infos.currentMileage ? filterEmpty(infos.currentMileage / 10) : filterEmpty(infos.currentMileage), "Km"), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u8F66\u901F:\u3000", infos.currentSpeed ? filterEmpty(infos.currentSpeed / 10) : filterEmpty(infos.currentSpeed), "Km/h"), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u4FE1\u53F7\u503C:\u3000", filterEmpty(infos.simSignal)), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u884C\u8F66\u72B6\u6001:\u3000", infos.vehichleStatus || infos.vehichleStatus === 0 ? function (info) {
        // info
        var a = {
          VEHICLE_STARTED: '车辆启动',
          VEHICLE_POWER_OFF: '车辆熄火',
          VEHICLE_OTHER_STATUS: '其他状态',
          VEHICLE_LOCKED: '车辆上锁',
          VEHICLESTATUS_EXCEPTION: '异常状态',
          VEHICLESTATUS_INVALID: '无效',
          VEHICLESTATUS_UNKNOWN: '未知状态'
        };
        var b = {
          1: '车辆启动',
          2: '车辆熄火',
          3: '其他状态',
          4: '车辆上锁',
          254: '异常状态',
          255: '无效',
          65535: '未知状态'
        };
        return a[info] == '' || a[info] == undefined ? b[info] : a[info];
      }(infos.vehichleStatus) : "--"), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u5145\u7535\u72B6\u6001:\u3000", infos.chargeStatus || infos.chargeStatus === 0 ? function (info) {
        // info
        var b = {
          1: '停车充电',
          2: '行驶充电',
          3: '未充电状态',
          4: '充电完成',
          254: '异常状态',
          255: '无效',
          65535: '未知状态'
        };
        return b[info];
      }(infos.chargeStatus) : "--"), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u8FD0\u884C\u6A21\u5F0F:\u3000", infos.runningMode || infos.runningMode === 0 ? function (info) {
        // info
        var a = {
          ACC_OFF_MODE: '下电',
          SELFEXAMINE_MODE: '自检',
          PARKING_MODE: '驻车',
          READY_MODE: '启动',
          DRIVING_MODE: '行驶',
          FAULT_MODE: '故障',
          CHARGRING_MODE: '充电',
          RUNNINGMODE_EXCEPTION: '异常',
          RUNNINGMODE_INVALID: '无效',
          RUNNINGMODE_UNKNOWN: '未知状态'
        };
        var b = {
          0: '下电',
          1: '自检',
          2: '驻车',
          3: '启动',
          4: '行驶',
          5: '故障',
          6: '充电',
          254: '异常',
          255: '无效',
          1048575: '未知状态'
        };

        return a[info] == '' || a[info] == undefined ? b[info] : a[info];
      }(infos.runningMode) : "--"), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "ACC\u7535\u95E8\u9501:\u3000", infos.accStatus ? 'ACC ON' : 'ACC OFF'), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "DC-DC\u72B6\u6001:\u3000", infos.dcStatus || infos.dcStatus === 0 ? function (info) {
        // info
        var a = {
          DCDC_WORKING: '工作',
          DCDC_DISCONNECTED: '断开',
          DCDC_EXCEPTION: '异常',
          DCDC_INVALID: '无效',
          DCDC_UNKNOWN: '未知状态'
        };
        var b = {
          1: '工作',
          2: '断开',
          254: '异常',
          255: '无效',
          1048575: '未知状态'
        };

        return a[info] == '' || a[info] == undefined ? b[info] : a[info];
      }(infos.dcStatus) : "--"), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u5907\u7528\u7535\u6C60:\u3000", infos.standbyBattery || infos.standbyBattery === 0 ? function (info) {
        // info
        var a = {
          STAND_BY_BATTERY_NORMAL: '正常',
          STAND_BY_BATTERY_LOW_VOLTAGE: '低电告警',
          STAND_BY_BATTERY_EXCEPTION: '异常',
          STAND_BY_BATTERY_INVALID: '无效',
          STAND_BY_BATTERY_UNKNOWN: '未知状态'
        };
        var b = {
          0: '正常',
          1: '低电告警',
          254: '异常',
          255: '无效',
          65535: '未知状态'
        };

        return a[info] == '' || a[info] == undefined ? b[info] : a[info];
      }(infos.standbyBattery) : "--"), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u5DE5\u4F5C\u6863\u4F4D:\u3000", infos.gear || infos.gear === 0 ? function (info) {
        // if (info.gear == undefined) return '--'
        // info
        var a = {
          LOW_GEAR: '低速档',
          MID_GEAR: '中速档',
          HIGH_GEAR: '高速档',
          SHIFT_P: '倒车P档',
          GEAR_EXCEPTION: '未知状态',
          GEAR_INVALID: '未知状态',
          GEAR_UNKNOWN: '未知状态'
        };
        var b = {
          0: '低速档',
          1: '中速档',
          2: '高速档',
          3: '倒车P档',
          254: '未知状态',
          255: '未知状态',
          65535: '未知状态'
        };

        return a[info] == '' || a[info] == undefined ? b[info] : a[info];
      }(infos.gear) : "--"), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u80CE\u538B:\u3000", infos.tirePressure ? '正常' : '异常'), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u603B\u7535\u538B:\u3000", infos.totalVoltage / 10 < 0 || infos.totalVoltage / 10 > 1000 ? '异常' : filterEmpty(infos.totalVoltage / 10) + "V"), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u603B\u7535\u6D41:\u3000", infos.totalCurrent / 10 < -1000 || infos.totalCurrent / 10 > 1000 ? '异常' : filterEmpty(infos.totalCurrent / 10) + "A"), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "BMS\u6E7F\u5EA6\u7B49\u7EA7:\u3000", infos.bmsHumidity || infos.bmsHumidity === 0 ? function (info) {
        // info
        var a = {
          LOW_HUMIDITY: "湿度低",
          MEDIUM_HUMIDITY: "湿度中等",
          HIGH_HUMIDITY: "湿度高",
          BMS_HUMIDITY_EXCEPTION: "异常",
          BMS_HUMIDITY_INVALID: "无效",
          BMS_HUMIDITY_UNKNOWN: "未知状态"
        };
        var b = {
          0: "湿度低",
          1: "湿度中等",
          2: "湿度高",
          254: "异常",
          255: "无效",
          65535: "未知状态"
        };

        return a[info] == '' || a[info] == undefined ? b[info] : a[info];
      }(infos.bmsHumidity) : "--"), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u978D\u5EA7\u89E3\u9501\u72B6\u6001:\u3000\u65E0\u6548")), (0, _jsx3.default)("h5", {
        style: { fontSize: '20px', lineHeight: "50px" }
      }, void 0, "\u5F53\u524D\u8F66\u8F86\u4F4D\u7F6E\uFF1A"), (0, _jsx3.default)("div", {
        style: { width: '100%', overflow: 'hidden' }
      }, void 0, (0, _jsx3.default)("div", {
        id: "container",
        style: { width: "80%", height: "350px", float: 'left' }
      }), (0, _jsx3.default)(_card2.default, {
        style: { width: '20%', float: 'right', height: '350px' },
        title: "\u4E0A\u62A5\u4FE1\u606F"
      }, void 0, (0, _jsx3.default)("p", {}, void 0, "\u4E0A\u62A5\u4F4D\u7F6E\uFF1A", (0, _jsx3.default)("span", {}, void 0, this.state.area)), (0, _jsx3.default)("p", {}, void 0, "\u6700\u65B0\u4F4D\u7F6E\u7EA0\u504F\u6709\u6548\u65F6\u95F4\uFF1A", (0, _jsx3.default)("span", {}, void 0, reportingTime2)), (0, _jsx3.default)("p", {}, void 0, "\u6700\u65B0\u5B9A\u4F4D\u6570\u636E\u4E0A\u62A5\u65F6\u95F4\uFF1A", (0, _jsx3.default)("span", {}, void 0, reportingTime))))), (0, _jsx3.default)(TabPane, {
        tab: "\u53EF\u5145\u7535\u50A8\u80FD"
      }, "3", (0, _jsx3.default)(_row2.default, {
        className: "device-detail-banner"
      }, void 0, (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u7535\u6C60\u5145\u7535\u6B21\u6570:\u3000", filterEmpty(bmsVolDatas.chargedTimes), "\u6B21"), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u7535\u6C60\u7EC4\u989D\u5B9A\u5BB9\u91CF:\u3000", filterEmpty(bmsVolDatas.batteryPackRatedCapacity / 100), "Ah/\u4F4D"), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u7535\u6C60\u7EC4\u989D\u5B9A\u603B\u7535\u538B:\u3000", filterEmpty(bmsVolDatas.batteryPackRatedVoltage / 100), "V/\u6B21"), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u7535\u6C60\u7C7B\u578B:\u3000", bmsVolDatas.batteryType || bmsVolDatas.batteryType == 0 ? function (info) {
        // info
        var a = {
          LEAD_ACID: '铅酸电池',
          NI_MH: '镍氢电池',
          LITHIUM_IRON_PHOSPHATE: '磷酸铁锂电池',
          LITHIUM_MANGANATE: '锰酸锂电池',
          LITHIUM_COBALT_OXIDE: '钴酸锂电池',
          TERNARY_MATERIAL: '三元材料电池',
          POLYMER_LI_ION: '聚合物锂离子电池',
          LITHIUM_TITANATE: '钛酸锂电池',
          OTHER_TYPE: '其他电池'
        };
        var b = {
          1: '铅酸电池',
          2: '镍氢电池',
          3: '磷酸铁锂电池',
          4: '锰酸锂电池',
          5: '钴酸锂电池',
          6: '三元材料电池',
          7: '聚合物锂离子电池',
          8: '钛酸锂电池',
          255: '其他电池'

        };
        return a[info] == '' || a[info] == undefined ? b[info] : a[info];
      }(bmsVolDatas.batteryType) : "--"), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u5355\u4F53\u7535\u6C60\u603B\u6570:\u3000", batNum, "\u4E2A"), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u6E29\u5EA6\u63A2\u9488\u4E2A\u6570:\u3000", tempNum, "\u4E2A"), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u53EF\u5145\u7535\u50A8\u80FD\u88C5\u7F6E\u5B50\u7CFB\u7EDF\u7535\u538B:\u3000", bmsVolDatas.voltage / 10 < -0 || bmsVolDatas.voltage / 10 > 6000 ? '异常' : filterEmpty(bmsVolDatas.voltage / 10) + "V"), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u53EF\u5145\u7535\u50A8\u80FD\u88C5\u7F6E\u5B50\u7CFB\u7EDF\u7535\u6D41:\u3000", bmsVolDatas.current / 10 < -1000 || bmsVolDatas.current / 10 > 1000 ? '异常' : filterEmpty(bmsVolDatas.current / 10) + "A"), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u6700\u9AD8\u7535\u538B\u7535\u6C60\u5355\u4F53\u4EE3\u53F7:\u3000", vehExtremeChargingDeviceData.maxVolPos || '--'), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u7535\u6C60\u5355\u4F53\u7535\u538B\u6700\u9AD8\u503C:\u3000", vehExtremeChargingDeviceData.maxVolVal / 1000 || '--', "V"), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u6700\u4F4E\u7535\u538B\u7535\u6C60\u5355\u4F53\u4EE3\u53F7:\u3000", vehExtremeChargingDeviceData.minVolPos || '--'), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u7535\u6C60\u5355\u4F53\u7535\u538B\u6700\u4F4E\u503C:\u3000", vehExtremeChargingDeviceData.minVolVal / 1000 || '--', "V"), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u6700\u9AD8\u6E29\u5EA6\u63A2\u9488\u5E8F\u53F7:\u3000", vehExtremeChargingDeviceData.maxTempPos || '--'), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u6700\u9AD8\u7535\u6C60\u6E29\u5EA6:\u3000", vehExtremeChargingDeviceData.maxTempVal || '--', "\u2103"), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u6700\u4F4E\u6E29\u5EA6\u63A2\u9488\u5E8F\u53F7:\u3000", vehExtremeChargingDeviceData.minTempPos || '--'), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u6700\u4F4E\u7535\u6C60\u6E29\u5EA6:\u3000", vehExtremeChargingDeviceData.minTempVal || '--', "\u2103"), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u6700\u9AD8\u6E29\u5EA6\u5B50\u7CFB\u7EDF\u53F7:\u3000", vehExtremeChargingDeviceData.maxTempIdx || '--')), (0, _jsx3.default)(_row2.default, {
        className: "device-detail-banner"
      }, void 0, (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u5355\u4F53\u7535\u6C60\u7535\u538B:\u3000", bmsVolDatas.volList ? bmsVolDatas.volList.map(function (mp, item) {
        return (0, _jsx3.default)("div", {}, item, "\u5355\u4F53\u7535\u6C60" + item + "\uFF1A" + mp / 1000 + "V");
      }) : ''))), (0, _jsx3.default)(TabPane, {
        tab: "\u9A71\u52A8\u7535\u673A"
      }, "4", (0, _jsx3.default)(_row2.default, {
        className: "device-detail-banner"
      }, void 0, (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u9A71\u52A8\u7535\u673A\u72B6\u6001:\u3000", qddj.driveStatus ? function (info) {
        // info
        var a = {
          POWER_CONSUMPTION: "耗电",
          GENERATE_ELECTRICITY: "发电",
          SHUTDOWN: "关闭",
          READY: "准备",
          DRIVINGMOTORSTATUS_EXCEPTION: "异常",
          DRIVINGMOTORSTATUS_INVALID: "无效",
          DRIVINGMOTORSTATUS_UNKNOWN: "未知状态"
        };
        var b = {
          1: '耗电',
          2: '发电',
          3: '关闭',
          4: '准备',
          254: '异常',
          255: '无效',
          65535: '未知状态'
        };

        return a[info] == '' || a[info] == undefined ? b[info] : a[info];
      }(qddj.driveStatus) : "--"), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u9A71\u52A8\u7535\u673A\u63A7\u5236\u5668\u6E29\u5EA6:\u3000", filterEmpty(qddj.ctrlTemp), "\xB0C"), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u9A71\u52A8\u7535\u673A\u8F6C\u901F:\u3000", qddj.driveSpeed < -2000 || qddj.driveSpeed > 45531 ? '异常' : filterEmpty(qddj.driveSpeed) + "r/min"), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u9A71\u52A8\u7535\u673A\u626D\u77E9:\u3000", qddj.driveTorque < -2000 || qddj.driveTorque > 4553 ? '异常' : filterEmpty(qddj.driveTorque) + "N*m"), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u9A71\u52A8\u7535\u673A\u6E29\u5EA6:\u3000", qddj.driveTemp < -40 || qddj.driveTemp > 210 ? '无效' : filterEmpty(qddj.driveTemp) + "\xB0C"), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u7535\u673A\u8F93\u5165\u7535\u538B:\u3000", qddj.busVoltage / 10 < -40 || qddj.busVoltage / 10 > 6000 ? '异常' : filterEmpty(qddj.busVoltage / 10) + "V"), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u7535\u673A\u6BCD\u7EBF\u7535\u6D41:\u3000", qddj.busCurrent / 10 < -1000 || qddj.busCurrent / 10 > 1000 ? '异常' : filterEmpty(qddj.busCurrent / 10) + "A"), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u9006\u53D8\u5668\u6E29\u5EA6:\u3000", qddj.inverterTemp < -40 || qddj.inverterTemp > 210 ? '异常' : filterEmpty(qddj.inverterTemp) + "\xB0C"), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u7535\u673A\u529F\u7387:\u3000", qddj.power / 100 / 1000 < 0 || qddj.power / 100 / 1000 > 60 ? '异常' : filterEmpty(qddj.power / 100 / 1000) + "Kw"), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u5B9E\u9645\u8F93\u51FA\u626D\u77E9:\u3000", this.filterOutputTorque(qddj.actualOutputTorque)), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u9632\u76D7\u63A7\u5236:\u3000", qddj.securityControlStatus || qddj.securityControlStatus === 0 ? function (info) {
        // info
        var b = {
          1: '锁车解防',
          2: '锁车设防',
          3: '解锁设防',
          4: '解锁解防',
          254: '异常',
          255: '无效',
          65535: '未知状态'
        };

        return b[info];
      }(qddj.securityControlStatus) : "--"), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u8FB9\u6491\u5F00\u5173:\u3000\u65E0\u6548"), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u80FD\u91CF\u6D88\u8017\u7B49\u7EA7:\u3000", filterEmpty(qddj.energyConsumptionLevel * 40) + "w"), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u80FD\u91CF\u56DE\u6536\u7B49\u7EA7:\u3000", filterEmpty(qddj.energyRecoveryLevel * 20) + "w"))), (0, _jsx3.default)(TabPane, {
        tab: "\u5145\u7535\u63A7\u5236\u5668"
      }, "5", (0, _jsx3.default)(_row2.default, {
        className: "device-detail-banner"
      }, void 0, (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u5B9E\u65F6\u8F93\u51FA\u7535\u6D41:\u3000", kzq.current / 10 < 0 || kzq.current / 10 > 1000 ? '异常' : filterEmpty(kzq.current / 10) + "A"), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u5B9E\u65F6\u8F93\u51FA\u7535\u538B:\u3000", kzq.voltage / 10 < 0 || kzq.voltage / 10 > 1000 ? '异常' : filterEmpty(kzq.voltage / 10) + "v"), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "BMS\u5C31\u7EEA\u6807\u5FD7:\u3000", kzq.bmsReadyFlag ? 'BMS准备好充电' : 'BMS未就绪'), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u5145\u7535\u673A\u5C31\u7EEA\u6807\u5FD7:\u3000", kzq.chargerReadyFlag ? 'OBC 准备好充电' : 'OBC 未就绪'), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u9700\u6C42\u7535\u6D41:\u3000", kzq.requireCurrent / 100 < 0 || kzq.requireCurrent / 100 > 1000 ? '异常' : filterEmpty(kzq.requireCurrent / 100) + "A"), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u9700\u6C42\u7535\u538B:\u3000", kzq.requireVoltage / 100 < 0 || kzq.requireVoltage / 100 > 1000 ? '异常' : filterEmpty(kzq.requireVoltage / 100) + "A"), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u5145\u7535\u6A21\u5F0F:\u3000", kzq.chargeMode ? function (info) {
        // info
        var a = {
          CHARGE_CONSTANT_VOLTAGE: '恒压充电',
          CHARGE_CONSTANT_CURRENT: '恒流充电',
          CHARGE_EXCEPTION: '异常',
          CHARGE_INVALID: '无效',
          CHARGE_UNKNOWN: '未知状态'
        };
        var b = {
          1: '恒压充电',
          2: '恒流充电',
          254: '异常',
          255: '无效',
          65535: '未知状态'
        };

        return a[info] == '' || a[info] == undefined ? b[info] : a[info];
      }(kzq.chargeMode) : "--"), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u5145\u7535\u7535\u538B\u6D4B\u91CF\u503C:\u3000", kzq.chargingVoltageValue / 100 < 0 || kzq.chargingVoltageValue / 100 > 1000 ? '异常' : filterEmpty(kzq.chargingVoltageValue / 100) + "V"), (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u5145\u7535\u7535\u6D41\u6D4B\u91CF\u503C:\u3000", kzq.chargingCurrentValue / 100 < 0 || kzq.chargingCurrentValue / 100 > 1000 ? '异常' : filterEmpty(kzq.chargingCurrentValue / 100) + "A"))), (0, _jsx3.default)(TabPane, {
        tab: "\u6545\u969C\u4FE1\u606F"
      }, "6", (0, _jsx3.default)(_row2.default, {
        className: "device-detail-banner"
      }, void 0, (0, _jsx3.default)(_col2.default, {
        span: 7,
        className: "ele-2"
      }, void 0, "\u6700\u9AD8\u62A5\u8B66\u7B49\u7EA7\uFF1A", leverArr[leverArr.length - 1] ? leverArr[leverArr.length - 1] : '--')), (0, _jsx3.default)(_row2.default, {
        className: "device-detail-banner1"
      }, void 0, (0, _jsx3.default)(_col2.default, {
        className: "ele-2"
      }, void 0, "MCCU\u6545\u969C\uFF1A", (0, _jsx3.default)("span", {}, void 0, gzxx.filter(function (item) {
        return item.alarmTypeName === 'COMPONENT_MCCU';
      }).length), (0, _jsx3.default)("div", {
        className: "box"
      }, void 0, gzxx.map(function (val, index) {
        if (val.alarmTypeName === 'COMPONENT_MCCU') {
          return (0, _jsx3.default)("div", {
            className: "err",
            onMouseEnter: _this7.showErrDetail.bind(_this7),
            "data-detail": (0, _stringify2.default)(val),
            title: _this7.state.warningLable
          }, "err" + index, "" + val.alarmCode);
        }
      }))), (0, _jsx3.default)(_col2.default, {
        className: "ele-2"
      }, void 0, "VCU\u6545\u969C\uFF1A", (0, _jsx3.default)("span", {}, void 0, gzxx.filter(function (item) {
        return item.alarmTypeName === 'COMPONENT_VCU';
      }).length), (0, _jsx3.default)("div", {
        className: "box"
      }, void 0, gzxx.map(function (val, index) {
        if (val.alarmTypeName === 'COMPONENT_VCU') {
          return (0, _jsx3.default)("div", {
            className: "err",
            onMouseEnter: _this7.showErrDetail.bind(_this7),
            "data-detail": (0, _stringify2.default)(val),
            title: _this7.state.warningLable
          }, "err" + index, "" + val.alarmCode);
        }
      }))), (0, _jsx3.default)(_col2.default, {
        className: "ele-2"
      }, void 0, "BMS\u6545\u969C\uFF1A", (0, _jsx3.default)("span", {}, void 0, gzxx.filter(function (item) {
        return item.alarmTypeName === 'COMPONENT_BMS';
      }).length), (0, _jsx3.default)("div", {
        className: "box"
      }, void 0, gzxx.map(function (val, index) {
        if (val.alarmTypeName === 'COMPONENT_BMS') {
          return (0, _jsx3.default)("div", {
            className: "err",
            onMouseEnter: _this7.showErrDetail.bind(_this7),
            "data-detail": (0, _stringify2.default)(val),
            title: _this7.state.warningLable
          }, "err" + index, "" + val.alarmCode);
        }
      }))), (0, _jsx3.default)(_col2.default, {
        className: "ele-2"
      }, void 0, "ICM\u6545\u969C\uFF1A", (0, _jsx3.default)("span", {}, void 0, gzxx.filter(function (item) {
        return item.alarmTypeName === 'COMPONENT_ICM';
      }).length), (0, _jsx3.default)("div", {
        className: "box"
      }, void 0, gzxx.map(function (val, index) {
        if (val.alarmTypeName === 'COMPONENT_ICM') {
          return (0, _jsx3.default)("div", {
            className: "err",
            onMouseEnter: _this7.showErrDetail.bind(_this7),
            "data-detail": (0, _stringify2.default)(val),
            title: _this7.state.warningLable
          }, "err" + index, "" + val.alarmCode);
        }
      }))), (0, _jsx3.default)(_col2.default, {
        className: "ele-2"
      }, void 0, "\u672A\u77E5\u6545\u969C\uFF1A", (0, _jsx3.default)("span", {}, void 0, gzxx.filter(function (item) {
        return item.alarmTypeName === 'UNKNOWN_COMPONENT_TYPE';
      }).length), (0, _jsx3.default)("div", {
        className: "box"
      }, void 0, gzxx.map(function (val, index) {
        if (val.alarmTypeName === 'UNKNOWN_COMPONENT_TYPE') {
          return (0, _jsx3.default)("div", {
            className: "err",
            onMouseEnter: _this7.showErrDetail.bind(_this7),
            "data-detail": (0, _stringify2.default)(val),
            title: _this7.state.warningLable
          }, "err" + index, "" + val.alarmCode);
        }
      })))), (0, _jsx3.default)(_row2.default, {
        className: "device-detail-banner"
      }, void 0, (0, _jsx3.default)(_col2.default, {
        className: "ele-2"
      }, void 0, "\u6545\u969C\u5386\u53F2", (0, _jsx3.default)(_table2.default, {
        pagination: paginations,
        columns: columnTwo,
        dataSource: errData,
        onChange: this.onChange.bind(this)
      }))))));
      // return (

      // );
    }
  }]);
  return Main;
}(_react.Component);

exports.default = (0, _tpl2.default)({
  id: "device-detail", //应用关联使用的redux
  component: Main, //接收数据的组件入口
  url: ""
});

/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "index.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


//////////////////
// WEBPACK FOOTER
// ./src/containers/device/detail/index.jsx
// module id = 940
// module chunks = 0